import React from 'react';

const SvgPlus = () => (
  <svg viewBox="0 0 20 20" width="1em" height="1em">
    <path d="M8.2 11.8H2.9V8.2h5.3V3h3.5v5.3H17v3.5h-5.3V17H8.2v-5.2z" fill="currentColor" />
  </svg>
);

export default SvgPlus;
